import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseService } from './base.service';
import { TokenAuth, TokenAuthOtp } from '../models/tokenauth';
import { CookieService } from 'ngx-cookie-service';
@Injectable({
  providedIn: 'root'
})
export class TokenAuthService extends BaseService {
  constructor(
    private httpClient: HttpClient,
    baseService: BaseService,
    private cookieService: CookieService
  ) {
    super(httpClient, baseService.router, baseService.translate);
  }

  authenticate(tokenAuth: TokenAuth): Observable<any> {
    const url = `${this.apiUrl}TokenAuth/Authenticate`;
    const body = { userNameOrEmailAddress: tokenAuth.userNameOrEmailAddress, password: tokenAuth.password, rememberClient: tokenAuth.rememberClient, recaptchaToken: tokenAuth.recaptchaToken};

    return this.httpClient.post<any>(url, body)
    .pipe(map(response => {
      const result = response?.result;
    
      if (result && (result.type === 'Success' || result.type === 'success') && result.accessToken) {
        this.setCurrentUser(result);
        localStorage.setItem('lang', 'ar');
        localStorage.setItem('currentUser', JSON.stringify(result));
      }
    
      return result;
    }));
  }

  authenticateWithOtp(tokenAuthotp: TokenAuthOtp): Observable<any> {
    const url = `${this.apiUrl}TokenAuth/AuthenticateOtp`;
    const body = { phoneNumber: tokenAuthotp.phoneNumber};

    return this.httpClient.post<any>(url, body)
    .pipe(map(response => {
      if (response && response.result) {
        this.setCurrentUser(response.result); // Set user data in BaseService
        localStorage.setItem('lang', 'ar')
      }
      return response.result;
    }));
  }

  logout(): void {
    this.setCurrentUser(null);
    localStorage.removeItem('currentUser');
  }

  currentUserValue(): any {
    return this.getCurrentUser();
  }
}